export const getDriversState = store => store.admin.drivers;
export const getDriversVerificationState = store => store.admin.driversVerification;

export const getClientsState = store => store.admin.clients;

export const getOffersState = store => store.admin.offers;

export const getTradesState = store => store.admin.trades;
export const getArbitrationsState = store => store.admin.arbitrations;